// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Procedures_Content_Content_Procedure($location_ids: [uuid!]!) {
  vaxiom_sys_organizations(where: { _id: { _in: $location_ids } }) {
    id
  }
}

`